export default __webpack_public_path__ + "static/media/pencil_owl.be601bb5.jpg";